import MediaPreview from './MediaPreview.vue'

MediaPreview.install = (Vue) => {
    Vue.component(MediaPreview.name, MediaPreview)
}

export default MediaPreview
